module.exports = __webpack_public_path__ + "static/media/fa-brands-400.0cb5a5c0.svg";